import moment from 'moment';
import { ISO_DATE_FORMAT, MOMENT_DEFAULT_DATE_FORMAT } from '../../../../utilities';

const formatMarketDate = (marketDate: string): string =>
  moment(marketDate, MOMENT_DEFAULT_DATE_FORMAT).format(ISO_DATE_FORMAT);
export default formatMarketDate;
